import { render, staticRenderFns } from "./UniversalDialog.vue?vue&type=template&id=7c3254b6&scoped=true"
import script from "./UniversalDialog.vue?vue&type=script&lang=js"
export * from "./UniversalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3254b6",
  null
  
)

export default component.exports